import styled from 'styled-components';

import Image from '@stencil/image';

export const TaReviewWrapDiv = styled.div(
  props => `
  display:flex;
  flex-direction:row;
  flex-wrap:wrap;
  background-color: #00b087;
  align-items: center;
  justify-content: center;
  padding-top: ${props.theme.spacing.base};
  padding-bottom: ${props.theme.spacing.base};
  width: 25%;
  border-radius: ${props.theme.misc.borderRadius.large};
`,
);

export const TripAdvisorTextWrapper = styled.p(
  props => `
  color:${props.theme.colors.goWhite.base};
  font-size: ${props.theme.font.custom(22)};
  align-items: center;
  padding-top: ${props.theme.spacing.small};
  padding-bottom: ${props.theme.spacing.small};
`,
);

export const TaAvgReviewTextWrapperDiv = styled.p(
  props => `
  display:flex;
  flex-wrap:wrap;
  flex-direction: row;
  width:100%;
  padding-top: ${props.theme.spacing.xsmall};
  padding-bottom: ${props.theme.spacing.xsmall};
  align-items: baseline;
    justify-content: center;
`,
);

export const TaAvgReviewTextWrapper = styled.span(
  props => `
  color:${props.theme.colors.goWhite.base};
  font-size: 3.8rem;
  align-items: center;
  font-weight: bold;
`,
);

export const TaTotalReviewTextWrapper = styled.span(
  props => `
  color:${props.theme.colors.goWhite.base};
  font-size: 2.6rem;
  align-items: center;
  line-height: 1.1;
  font-weight: bold;
`,
);

export const TaReviewCountTextWrapper = styled.p(
  props => `
  display:flex;
  flex-wrap:wrap;
  color:${props.theme.colors.goWhite.base};
font-size: ${props.theme.font.custom(14)};
align-items: center;
padding-top: ${props.theme.spacing.small};
padding-bottom: ${props.theme.spacing.small};
`,
);

export const RatingImage = styled(Image)(
  props => `
    display: flex;
    width: 11.9rem
    height: 2rem;
`,
);
